import React from "react";

const Clients = ({ clients, clientDoesntHaveRutMessage = '' }) => {
    return (
        <div>
            <div className="w-full sm:max-w-md mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                <h2 className="mb-3 text-gray-900 text-lg font-bold">
                    Asistentes
                </h2>
                <table className="w-full">
                    <tbody>
                        <tr>
                            <th className="text-left">Nombre</th>
                            <th className="text-left">Apellido</th>
                            <th className="text-left">R.U.N</th>
                        </tr>
                        {clients.map(({ name, lastname, rut }) => (
                            <tr>
                                <td>{name}</td>
                                <td>{lastname}</td>
                                <td>{rut || clientDoesntHaveRutMessage}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Clients;
